import { render, staticRenderFns } from "./aideRole.vue?vue&type=template&id=05c7e8a6&"
import script from "./aideRole.vue?vue&type=script&lang=js&"
export * from "./aideRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports